import { render, staticRenderFns } from "./sample.page.pug?vue&type=template&id=dc2104f4&scoped=true&lang=pug&external"
import script from "./sample.page.ts?vue&type=script&lang=js&external"
export * from "./sample.page.ts?vue&type=script&lang=js&external"
import style0 from "./sample.page.sass?vue&type=style&index=0&id=dc2104f4&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2104f4",
  null
  
)

export default component.exports